export default "__VITE_ASSET__CYEmhMOs__"